import { useQuery } from '@tanstack/react-query';
import { getCaseById } from 'services/ClaimscoreApiService/Cases';
import { Case } from 'services/ClaimscoreApiService/Cases/types';

const QUERY_KEY = 'getCaseById';

export const useGetCaseById = (caseId: string) => {
  return useQuery<Case, Error>({
    queryKey: [QUERY_KEY, caseId],
    queryFn: () => getCaseById(caseId),
    enabled: Boolean(caseId),
  });
};
